import './team-rivals.styles.scss';
import { Link } from 'react-router-dom';
import TeamBadge from '@/components/SHARED/team-badge/team-badge.component';
import TeamName from '@/components/SHARED/team-name/team-name.component';
import HelpLink from '@/components/SHARED/help-link/help-link.component';

// A team's rivals with the all-time series, and this season's record in
// rivalry and payback games. team: team document. teams: summary/teams
// map. teamLink(teamId) -> path.
const TeamRivals = ({ team, teams, teamLink }) => {
    const rivals = Object.entries(team.rivals ?? {});
    if (!rivals.length) return null;
    const r = team.record ?? {};
    const wl = (w, l) => `${w ?? 0}-${l ?? 0}`;

    return (
        <div className='g-card team-rivals'>
            <h3>Rivals <HelpLink section='rivalries' label='How rivalries work' /></h3>
            <ul className='rival-list'>
                {rivals.map(([id, s]) => {
                    const opp = teams?.[id];
                    return (
                        <li key={id}>
                            <TeamBadge team={opp} size='sm' />
                            <span className='rival-text'>
                                <Link to={teamLink(id)}><TeamName team={opp} id={id} /></Link>
                                {s.name && <span className='rival-name'>{s.name}</span>}
                            </span>
                            <span className='rival-series'>{seriesText(s)}</span>
                        </li>
                    );
                })}
            </ul>
            <p className='meta'>
                This season: {wl(r.rivalW, r.rivalL)} in rivalry games, {wl(r.paybackW, r.paybackL)} in payback games.
            </p>
        </div>
    )
}

// "Leads 4-1", "Trails 2-3", "Tied 2-2" or "No games yet".
function seriesText(s) {
    const w = s?.w ?? 0;
    const l = s?.l ?? 0;
    if (!w && !l) return 'No games yet';
    return `${w > l ? 'Leads' : w < l ? 'Trails' : 'Tied'} ${w}-${l}`;
}

export default TeamRivals
